import { render, staticRenderFns } from "./ImagPreview.vue?vue&type=template&id=88275062&scoped=true&"
import script from "./ImagPreview.vue?vue&type=script&lang=js&"
export * from "./ImagPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImagPreview.vue?vue&type=style&index=0&id=88275062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88275062",
  null
  
)

export default component.exports